module.exports = __webpack_public_path__ + "media/images/emblems/Wolfhald-1c449f75d8dff7f051bb799190d2dc1a.png";